import { createSlice, createSelector } from '@reduxjs/toolkit';
import { set } from 'lodash';

import FungibleTokens from 'services/fungible-tokens';
import {
  createParameterSelector,
  selectSliceFromShared
} from 'redux/selectors/topLevel';
import config from 'config';

const { OCC_CONTRACT,USDC_CONTRACT } = config;
const SLICE_NAME = 'tokensMetadata';

const initialState = {
  byContractName: {}
};

export async function getCachedContractMetadataOrFetch(contractName: string) {
  if (contractName === OCC_CONTRACT) {
    const [ftMetadata] = await FungibleTokens.getMtMetadataBase({ metadataIds: ['ft'] });
    return ftMetadata;
  }
  if (contractName === USDC_CONTRACT) {
    return FungibleTokens.getFtMetadata(USDC_CONTRACT);  }

  return FungibleTokens.getFtMetadata();
}

export const tokensMetadataSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setContractMetadata(state, { payload }) {
      const { metadata, contractName } = payload;
      set(state, ['byContractName', contractName], metadata);
    }
  }
});

export default tokensMetadataSlice;

// Top level selectors
const selectTokensMetadataSlice = selectSliceFromShared(
  SLICE_NAME,
  initialState
);

const getContractNameParam = createParameterSelector(
  (params) => params.contractName
);

export const selectContractsMetadata = createSelector(
  selectTokensMetadataSlice,
  ({ byContractName }) => byContractName
);

export const selectOneContractMetadata = createSelector(
  [selectContractsMetadata, getContractNameParam],
  (metadataByContractName, contractName) => {
    return metadataByContractName[contractName];
  }
);
